const APP_TITLE = 'LAD Custom Publishing';

const HEADING_SELECTOR = 'main h1, main h2, main h3, main [role="heading"]';

const toTitleCase = (value: string) =>
  value
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const getFallbackPageName = (pathname: string) => {
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) return 'Home';

  const lastReadableSegment = [...segments]
    .reverse()
    .find((segment) => !/^\d+$/.test(segment));

  if (!lastReadableSegment) return 'Home';

  return toTitleCase(decodeURIComponent(lastReadableSegment));
};

export const getPageName = (doc: Document, pathname: string) => {
  const heading = doc.querySelector<HTMLElement>(HEADING_SELECTOR);
  const headingText = heading?.textContent?.trim();

  return headingText || getFallbackPageName(pathname);
};

export const getDocumentTitle = (pageName: string) =>
  `${pageName} - ${APP_TITLE}`;
